/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_DescInputs */



/**
* | output |
* | --- |
* | "Change caption position of selected events" |
*
* @param {Caption_Position_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_desc = /** @type {((inputs?: Caption_Position_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la position des événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ändern Sie die Untertitelposition der ausgewählten Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia la posizione della didascalia degli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменить позицию подписи выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar la posición de subtítulos de los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更改所选事件的标题位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのキャプション位置を変更する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स की कैप्शन स्थिति बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterar a posição da legenda dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Change caption position of selected events")
});